export const START_FETCH_TRADE_RECORD = 'START_FETCH_TRADE_RECORD'
export const SUCCESS_FETCH_TRADE_RECORD = 'SUCCESS_FETCH_TRADE_RECORD'
export const FAILED_FETCH_TRADE_RECORD = 'FAILED_FETCH_TRADE_RECORD'

import getTradeRecord from 'controllers/school/getTradeRecord'

export const DEFAULT_PAGINATION = {
  activePage: 1,
  itemsCountPerPage: 10,
  totalItemsCount: 0,
}

export function fetchTradeRecord(schoolId, tradeInfo, pagination){

  return function(dispatch) {

    dispatch({
      type: START_FETCH_TRADE_RECORD,
      payload: {
        fetching: true
      }
    })

    const {
      activePage,
      itemsCountPerPage,
    } = pagination;

    const paramToServer = {
      ...tradeInfo,
      paging_or_not: 1,
      page_number: activePage,
      amount_per_page: itemsCountPerPage,
    }

    getTradeRecord(schoolId, paramToServer)
    .then((result) => {
      dispatch({
        type: SUCCESS_FETCH_TRADE_RECORD,
        payload: {...result, amount_per_page: itemsCountPerPage, fetching: false, hasPermission: true}
      })
    })
    .catch((err)  => {
      dispatch({
        type: FAILED_FETCH_TRADE_RECORD,
        payload: {
          fetching: false,
          hasPermission: false,
          err,
        }
      })
    })
  }
}

const initState = {
  list: [],
  pagination: DEFAULT_PAGINATION,
}

export default function financeTable(state = initState, action){
  switch(action.type){
    case START_FETCH_TRADE_RECORD: {
      return {...state, ...action.payload}
    }
    case SUCCESS_FETCH_TRADE_RECORD: {
      let {
        result_list,
        current_page_number,
        amount_per_page,
        total_record_amount,
        fetching,
        hasPermission,
        school_has_traderecord,
      } = action.payload;

      return {
        ...state,
        list: result_list,
        fetching,
        hasPermission,
        school_has_traderecord,
        pagination: {
          itemsCountPerPage: amount_per_page,
          activePage: current_page_number,
          totalItemsCount: total_record_amount,
        }
      }
    }
    case FAILED_FETCH_TRADE_RECORD: {
      return {...state, err: action.payload.err, hasPermission: action.payload.hasPermission, fetching: action.payload.fetching}
    }

    default: return {...state}
  }
}



// WEBPACK FOOTER //
// ./src/containers/tables/FinanceTable/ducks.js